import { render, staticRenderFns } from "./ProfileTalentEndorsementsList.vue?vue&type=template&id=d59af4f8"
import script from "./ProfileTalentEndorsementsList.vue?vue&type=script&lang=js"
export * from "./ProfileTalentEndorsementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports